export default "__VITE_ASSET__BHzB8eIf__"